import useAllPricing from "features/subscriptions/datahooks/useAllPricing";
import useWorkspaceSubscriptionMutations from "features/subscriptions/datahooks/useWorkspaceSubscriptionMutations";

import { Button, type ButtonProps } from "common/components/ui/Button";
import { trackMetaPixel } from "common/helpers/utils";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

export default function StartTrialButton({
  className,
  size,
}: {
  className?: string;
  size: ButtonProps["size"];
}) {
  const { relativeNavigate } = useWorkspaceNavigate();

  const { allPricing, isLoadingAllPricing } = useAllPricing();
  const { createWorkspaceSubscription, isCreatingWorkspaceSubscription } =
    useWorkspaceSubscriptionMutations();

  async function startTrial() {
    const plan = allPricing.find(
      ({ period_unit, item_type, subscription_type, period }) =>
        period_unit === "month" &&
        item_type === "plan" &&
        subscription_type === "user" &&
        period === 1,
    );

    await createWorkspaceSubscription({
      planId: plan.id,
      type: "user",
      count: 1,
      paymentSourceId: null,
    });

    trackMetaPixel("trackCustom", "FreeTrialApp");
    relativeNavigate("onboarding?welcome-screen=true");
  }

  return (
    <Button
      size={size}
      isLoading={isLoadingAllPricing || isCreatingWorkspaceSubscription}
      onClick={startTrial}
      className={className}
    >
      Start 14-day free trial
    </Button>
  );
}
